import React from 'react';
import { InlineWidget, useCalendlyEventListener, EventScheduledEvent } from 'react-calendly';

import colors from '@front/common/src/utils/colors';

type CalendlyWidgetProps = {
  onEventScheduled?: (e: EventScheduledEvent) => void;
  showDetails?: boolean;
  url: string;
  prefilledInformations?: {
    email?: string;
    name?: string;
    phone?: string;
  };
};
const CalendlyWidget = ({
  onEventScheduled,
  showDetails = true,
  url,
  prefilledInformations,
}: CalendlyWidgetProps) => {
  useCalendlyEventListener({
    onEventScheduled,
  });

  return (
    <InlineWidget
      styles={{
        // Has to do this to avoid weird conflict scrolling between our page and calendly Iframe on Iphone,
        // preventing the user to submit
        height: '1000px',
      }}
      pageSettings={{
        hideLandingPageDetails: true,
        hideGdprBanner: true,
        hideEventTypeDetails: !showDetails,
        primaryColor: colors.primary100.replace('#', ''),
        textColor: colors.ink100.replace('#', ''),
      }}
      url={url}
      prefill={{
        email: prefilledInformations?.email,
        name: prefilledInformations?.name,
        customAnswers: {
          a1: prefilledInformations?.phone,
        },
      }}
    />
  );
};

export default CalendlyWidget;
